import React, { createContext, useContext, useEffect, useState } from 'react'

const NavigationContext = createContext()

export const useNavigationData = () => {
  const context = useContext(NavigationContext)
  if (!context) {
    throw new Error('useNavigationData must be used within a NavigationProvider')
  }
  return context
}

export const NavigationProvider = ({ children }) => {
  const [navigationItems, setNavigationItems] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchNavigationItems = async () => {
      try {
        setIsLoading(true)
        setError(null)

        const response = await fetch('/navigation/navigation-items.json')

        if (!response.ok) {
          throw new Error(
            `Failed to fetch navigation items: ${response.status} ${response.statusText}`
          )
        }

        const data = await response.json()
        setNavigationItems(data)
      } catch (err) {
        console.error('Error fetching navigation items:', err)
        setError(err.message)
        // Fallback to empty object to prevent app from breaking
        setNavigationItems({})
      } finally {
        setIsLoading(false)
      }
    }

    fetchNavigationItems()
  }, [])

  const value = {
    navigationItems,
    isLoading,
    error
  }

  return <NavigationContext.Provider value={value}>{children}</NavigationContext.Provider>
}
